import http from './axiosInstance'
import errorHandler from '../transformers/axiosErrors'
import {
  ApiResponse,
  LinkedinRecipientInfo,
  LinkedinReportPayload,
} from '@/types'

export const latestReport = async (): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.get(`latestlinkedin`)
    resp.data = response.data.data
  } catch (e) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}

export const getLinkedinReport = async (
  payload: LinkedinReportPayload
): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.post('/linkedin/report', payload)
    resp.data = response.data
  } catch (e: any) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}

interface HistoryParams {
  page: number
  sortBy: string
  sortDir: string
}

export const getLinkedinHistory = async (params: HistoryParams) => {
  const resp = { data: null, error: null, meta: null }
  try {
    const response = await http.get('/linkedin-scans?', { params })
    resp.data = response.data.data
    resp.meta = response.data.meta
  } catch (e: any) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}

export const getLinkedinRecipientInfo = async (recipientUrl: string) => {
  const resp = { data: null as LinkedinRecipientInfo | null, error: null }
  try {
    const { data } = await http.post('/linkedin/recipient', {
      linkedin_profile_url: recipientUrl,
    })
    resp.data = data
  } catch (e: any) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}

export const getLinkedinProfileTopSkills = async () => {
  const resp = { data: [] as string[], error: null }
  try {
    const { data } = await http.get('/linkedin/top-skills')
    resp.data = data
  } catch (e: any) {
    resp.error = e.isAxiosError ? errorHandler(e) : e
  }
  return resp
}
